import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_INCOME_SUCCESS,
  UPDATE_EXPENSE_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../actions/types'

const expense = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.expense || state

    case UPDATE_INCOME_SUCCESS:
    case UPDATE_EXPENSE_FAILURE:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      return payload.expense || state

    default:
      return state
  }
}

export default expense;
